import React from 'react';
import { Mail, Clock, Zap } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-dark-surface/30">
      <div className="max-w-7xl mx-auto content-padding">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Get in <span className="brand-gradient">Touch</span>
          </h2>
          <p className="text-lg text-dark-muted max-w-2xl mx-auto">
            Ready to transform your ideas into powerful applications? Contact us today.
          </p>
        </div>

        {/* Contact Information - Minimal */}
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Email */}
            <div className="bg-dark-bg border border-dark-border rounded-xl p-8 hover:border-brand/50 transition-all duration-300 group">
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-brand to-brand-light rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Mail className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Email Us</h3>
                <a 
                  href="mailto:support@hyperionai-ltd.com"
                  className="text-lg text-brand hover:text-brand/80 transition-colors"
                >
                  support@hyperionai-ltd.com
                </a>
                <p className="text-sm text-dark-muted mt-2">
                  We respond within 24 hours
                </p>
              </div>
            </div>

            {/* Business Hours */}
            <div className="bg-dark-bg border border-dark-border rounded-xl p-8 hover:border-brand/50 transition-all duration-300 group">
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-brand-light to-highlight rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Clock className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Business Hours</h3>
                <p className="text-lg text-brand">24/7 Support</p>
                <p className="text-sm text-dark-muted mt-2">
                  Always available for your needs
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-12 bg-gradient-to-br from-brand/10 to-brand-light/10 border border-brand/30 rounded-xl p-8 text-center">
            <Zap className="w-8 h-8 text-brand mx-auto mb-4" />
            <h3 className="text-2xl font-semibold mb-3">Start Your Project Today</h3>
            <p className="text-dark-muted mb-6 max-w-xl mx-auto">
              Whether you need a mobile app, web application, or enterprise solution, 
              our expert team is ready to bring your vision to life.
            </p>
            <a 
              href="mailto:support@hyperionai-ltd.com?subject=Project Inquiry"
              className="action-btn inline-flex items-center gap-2"
            >
              <Mail className="w-5 h-5" />
              Contact Us Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

